import React from "react";

import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
} from "@mui/material";
import { Person, Article } from "@mui/icons-material";

export const TopFranchisesCards = ({ report }) => {
  if (!report?.topFranchises) return null;

  const { byPosts, byCreators } = report.topFranchises;

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} md={6}>
        <Card sx={{ height: "100%" }}>
          <CardContent>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <Article sx={{ color: "var(--success-color)" }} />
              <Typography variant="h6">
                Top Unidades por Posts
              </Typography>
            </Box>

            {byPosts && byPosts.length > 0 ? (
              <List sx={{ pt: 0 }}>
                {byPosts.slice(0, 5).map((franchise, index) => (
                  <ListItem
                    key={franchise.id}
                    sx={{
                      px: 0,
                      borderBottom: index < byPosts.length - 1 ? "1px solid #e0e0e0" : "none"
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <Chip
                        label={index + 1}
                        size="small"
                        sx={{
                          bgcolor: index === 0 ? "#FFD700" : index === 1 ? "#C0C0C0" : index === 2 ? "#CD7F32" : "var(--grey-200-color)",
                          color: index < 3 ? "white" : "var(--text-primary)",
                          fontWeight: "bold",
                          width: 28,
                          height: 28,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {franchise.name}
                        </Typography>
                      }
                      secondary={
                        <Box sx={{ display: "flex", gap: 2, mt: 0.5 }}>
                          <Typography variant="body2" color="text.secondary">
                            {franchise.postsCount} posts
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {franchise.creatorsCount} Membros
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 4 }}>
                Nenhum dado disponível
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card sx={{ height: "100%" }}>
          <CardContent>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <Person sx={{ color: "var(--primary-color)" }} />
              <Typography variant="h6">
                Top Unidades por Membros
              </Typography>
            </Box>

            {byCreators && byCreators.length > 0 ? (
              <List sx={{ pt: 0 }}>
                {byCreators.slice(0, 5).map((franchise, index) => (
                  <ListItem
                    key={franchise.id}
                    sx={{
                      px: 0,
                      borderBottom: index < byCreators.length - 1 ? "1px solid #e0e0e0" : "none"
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <Chip
                        label={index + 1}
                        size="small"
                        sx={{
                          bgcolor: index === 0 ? "#FFD700" : index === 1 ? "#C0C0C0" : index === 2 ? "#CD7F32" : "var(--grey-200-color)",
                          color: index < 3 ? "white" : "var(--text-primary)",
                          fontWeight: "bold",
                          width: 28,
                          height: 28,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {franchise.name}
                        </Typography>
                      }
                      secondary={
                        <Box sx={{ display: "flex", gap: 2, mt: 0.5 }}>
                          <Typography variant="body2" color="text.secondary">
                            {franchise.creatorsCount} Membros
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {franchise.postsCount} posts
                          </Typography>
                        </Box>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 4 }}>
                Nenhum dado disponível
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
